/**
 * Environment variables utility
 * This file provides a centralized way to access environment variables
 * and provides default values if environment variables are not set.
 */

// Debug mode
export const DEBUG = import.meta.env.VITE_DEBUG === 'true'

// API endpoint and configuration
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000'
export const API_TIMEOUT = Number(import.meta.env.VITE_API_TIMEOUT || 30000)

// App settings
export const APP_NAME = 'KinzShip'

// Helper function to validate required environment variables
export const validateEnv = (): boolean => {
  const requiredVars: string[] = []

  const missing = requiredVars.filter((key) => !import.meta.env[key])

  if (missing.length > 0) {
    console.error(`Missing required environment variables: ${missing.join(', ')}`)
    return false
  }

  return true
}

// Log environment info in debug mode
if (DEBUG) {
  console.log('Environment:', import.meta.env.MODE)
  console.log('Backend URL:', BACKEND_URL)
  console.log('API Timeout:', API_TIMEOUT)
}
